// AbSidebar — Modul-Navigation der Auftragsbestaetigungs-Arbeitsoberflaeche (Muster:
// components/lager/LagerSidebar.js). Kollabiert auf eine reine Icon-Leiste unterhalb des
// lg-Breakpoints (Labels werden per `hidden lg:inline` ausgeblendet, nicht die Buttons selbst).
// Regelsets/Monitoring sind echte RBAC-Einschraenkungen (Backend ADMIN-only) — kein
// "System aus"-Degradierungsfall, daher fuer Nicht-Admins bewusst nicht sichtbar.

import React from 'react';
import { LayoutDashboard, FileScan, ListChecks, Activity } from 'lucide-react';

const AbSidebar = ({ isDarkMode, t, active, onSelect, isAdmin }) => {
  const navItems = [
    { id: 'dashboard', icon: LayoutDashboard, label: t('ab.shell.navDashboard') },
    { id: 'documents', icon: FileScan, label: t('ab.shell.navDocuments') },
    ...(isAdmin ? [{ id: 'rulesets', icon: ListChecks, label: t('ab.rulesetsButton') }] : []),
    ...(isAdmin ? [{ id: 'monitoring', icon: Activity, label: t('ab.shell.navMonitoring') }] : []),
  ];

  const sidebarBg = isDarkMode
    ? 'bg-gray-900/60 border-r border-white/8 backdrop-blur-xl'
    : 'bg-white border-r border-slate-200';

  const itemBase = 'flex items-center gap-3 px-3 lg:px-4 py-2.5 rounded-xl text-sm font-medium transition-all w-full text-left justify-center lg:justify-start';

  const itemActive = isDarkMode
    ? 'bg-indigo-500/20 text-indigo-200 border border-indigo-400/25'
    : 'bg-indigo-50 text-indigo-700 border border-indigo-200';

  const itemIdle = isDarkMode
    ? 'text-white/60 hover:text-white hover:bg-white/8'
    : 'text-slate-600 hover:text-slate-900 hover:bg-slate-100';

  return (
    <aside className={`flex-shrink-0 w-14 lg:w-52 flex flex-col py-4 px-2 lg:px-3 ${sidebarBg}`}>
      <nav className="flex flex-col gap-1">
        {navItems.map(({ id, icon: Icon, label }) => {
          const isActive = active === id;
          return (
            <button
              key={id}
              type="button"
              onClick={() => onSelect(id)}
              className={`${itemBase} ${isActive ? itemActive : itemIdle}`}
              aria-current={isActive ? 'page' : undefined}
              title={label}
            >
              <Icon className="w-4 h-4 flex-shrink-0" />
              <span className="hidden lg:inline truncate">{label}</span>
            </button>
          );
        })}
      </nav>
    </aside>
  );
};

export default AbSidebar;
